import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bgVideo: [],
  userVideo: [],
  collections: [],
  currentCollection: 0,
  pixaBayVideo: [],
};

const videosSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    // Reducer to set vidboard avatars
    setBgVideo(state, action) {
      state.bgVideo = action.payload;
    },
    setCollections: (state, action) => {
      console.log("state v", action);
      state.collections = action.payload;
    },
    setCurrentCollection: (state, action) => {
      state.currentCollection = action.payload;
    },
    setPixaBayVideo: (state, action) => {
      state.currentCollection = action.payload;
    },
  },
});

export const {
  setBgVideo,
  setCollections,
  setCurrentCollection,
  setPixaBayVideo,
} = videosSlice.actions;
export default videosSlice.reducer;
